import local from './local.js'
import i18n from '@/lib/i18n.js'
import aws from '@/lib/aws/index.js'

// const version = process.env.APP_VERSION || 'local'
const version = '3.0.0'

const ENVIRONMENTS = {
  'c': { stage: 'prod', customers_only: true },
  'violet': {  stage: 'prod' },
  'staging': { stage: 'staging' },
  'tiger': { stage: 'test' },
  'test': { stage: 'test' },
  'neko': { stage: 'dev' },
  'giraffe': { stage: 'dev2' },
}

const DEFAULT_COUNTRY = 'jp'

let stage
let customers_only = false
let country

const getStage = () => {
  if (stage) return stage

  let env_name = ''
  // ドメインから環境および国を判定
  // サブドメインは「{環境名}-{国コード}」もしくは「{環境名}」
  const matches = location.hostname.match(/^([a-z]+)(-([a-z]+))??.senrigan-hihakai.com$/)
  if (matches) {
    env_name = matches[1]
    country = matches[3]
  }
  const env = ENVIRONMENTS[env_name]
  if (env) {
    stage = env.stage
    customers_only = env.customers_only || false
  } else if (local.getMode()) {
    stage = 'local'
  } else {
    stage = 'dev2'
  }
  console.log('stage is ' + stage)
  return stage
}

const setStageColor = () => {
  const defaultColor = 'skin-blue-light'
  const colors = {
    prod: 'skin-blue-light',
    staging: 'skin-red-light',
    test: 'skin-purple-light',
    dev: 'skin-green-light',
    dev2: 'skin-yellow-light',
    local: 'skin-yellow-light',
  }
  const el = document.querySelector('body')
  if (colors[stage] && colors[stage] !== defaultColor) {
    el.classList.replace(defaultColor, colors[stage])
  }
}

const isCustomersOnly = ()=> {
  return customers_only
}

const getVersion = () => {
  console.log('version is ' + version)
  return version
}


const localMode = () => {
  if (stage === 'local') return true
  else return false
}

const callLocal = (api, parms) => {
  return local.call(api, parms)
}

const getCountry = () => {
  return country || DEFAULT_COUNTRY
}

let initialized = false

const init = () => {
  if (initialized) return
  getStage()
  setStageColor()
  getVersion()
  aws.init(getCountry())
  i18n.setDefaultLocale()
  initialized = true
}

export default {
  getStage,
  isCustomersOnly,
  init,
  getVersion,
  localMode,
  callLocal,
  getCountry,
  DEFAULT_COUNTRY,
}
